import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import React, { useState } from 'react';
import TimezoneSelect from 'react-timezone-select';

dayjs.extend(utc);
dayjs.extend(timezone);

interface TimeSlot {
  id: string;
  startTime: string;
  endTime: string;
  isBooked: boolean;
}

interface AvailabilityData {
  date: string;
  slots: TimeSlot[];
}

interface Props {
  availability: AvailabilityData[];
  selectedSlot: string | null;
  onSelect: (slotId: string) => void;
}

const AvailabilityDisplay: React.FC<Props> = ({ availability, selectedSlot, onSelect }) => {
  const [selectedTz, setSelectedTz] = useState('Etc/UTC');
  return (
    <div className="space-y-6">
      {availability.map((day) => {
        return (
          <div key={day.date}>
            {/* Date Heading */}
            <div className="text-sm font-medium mb-3 ">
              <div className="mb-2 text-cardClr-text"> {dayjs.utc(day.date).format('dddd, MMM DD, YYYY')}</div>
              <TimezoneSelect
                styles={{
                  control: (base, state) => ({
                    ...base,
                    backgroundColor: 'var(--cardClr)',
                    borderColor: 'var(--cardClr-secondary)',
                    boxShadow: state.isFocused ? '0 0 0 1px var(--primary)' : 'none',
                    '&:hover': {
                      borderColor: 'var(--primary)',
                    },
                    color: 'var(--cardClr-text)',
                  }),
                  singleValue: (base) => ({
                    ...base,
                    color: 'var(--cardClr-text)',
                  }),
                  option: (base, state) => ({
                    ...base,
                    backgroundColor: state.isSelected
                      ? 'var(--primary)'
                      : state.isFocused
                        ? 'var(--cardClr-secondary)'
                        : 'var(--cardClr)',
                    color: state.isSelected ? 'var(--textClr-active)' : 'var(--cardClr-text)',
                    cursor: 'pointer',
                  }),
                  menu: (base) => ({
                    ...base,
                    backgroundColor: 'var(--cardClr)',
                    color: 'var(--cardClr-text)',
                  }),
                  placeholder: (base) => ({
                    ...base,
                    color: 'var(--textClr-inactive)',
                  }),
                }}
                value={selectedTz}
                onChange={(tz) => setSelectedTz(tz.value)}
              />
            </div>

            {/* Slots List */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {day.slots.map((slot) => {
                const label = `${dayjs.utc(slot.startTime).tz(selectedTz).format('hh:mm A')} - ${dayjs
                  .utc(slot.endTime)
                  .tz(selectedTz)
                  .format('hh:mm A')}`;
                return (
                  <button
                    key={slot.id}
                    onClick={(e) => {
                      e.stopPropagation();
                      onSelect(slot.id);
                    }}
                    className={`text-sm p-2 rounded-lg border transition ${
                      selectedSlot === slot.id
                        ? 'bg-primary text-textClr-active border-primary'
                        : 'bg-cardClr-secondary hover:bg-primary border-cardClr text-cardClr-text hover:text-textClr-active'
                    }`}
                  >
                    {label}
                  </button>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AvailabilityDisplay;
